import React from "react";
import PropTypes from "prop-types";
// import "../../../App.css";
import Background from "../../../assets/img/new-logo-4-bg.png";
import { fetchBreeders, deleteBreeder, attachSignature, getBreedersViaBreedType, updateBreeder } from "../../../actions/breeders";
import { fetchAnimalTypes } from "../../../actions/addAnimalType";
import {
  fetchBreedTypes, fetchBreedTypesByAnimal, fetchBreedInfo, fetchUpdatedBreedTypeById} from "../../../actions/addBreedType";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";


import moment from "moment";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import Switch from "react-switch";
import copy from 'copy-to-clipboard';
import DatePicker from "react-datepicker";
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import config from '../../../config';
import _ from 'lodash';
import { Activity } from '../../../components/activity';
import Select from "react-select";
const $ = window.$;
const { SearchBar } = Search;

const genderOptions = {
  0: "male",
  1: "female"
};

const cbOptions = {
  0: "yes",
  1: "no"
};

const statusOptions = {
  0: "Available",
  1: "Draft",
  2: "Sold"
};

var toaOptions = {};
var rtOptions = {};
var tableHeaderColumnData = [];
var _self;

const toCapitalize = (name) => {
    if (name && name.length > 1) {
     return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }
}

function normalToPascal(s) {
  return s.replace(/\w+/g,
    function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
}

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    // var intlCode = (match[1] ? '+1 ' : '')
    return [match[2], '-', match[3], '-', match[4]].join('');
  }
  return phoneNumberString;
}

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  state = {
    openNew: false,
    confirmDelete: false,
    contentData: [],
    breederData: [],
    cdDraft: [],
    cdSold: [],
    cdDeleted: [],
    selected: [],
    loadingDelete: false,
    deleteMRId: null,
    selectedTab: "All",
    clickedId: "",
    clickedIdDoPdf: "",
    type: "shop",
    current_row: null,
    dataBreederDelivery: [],
    startDate: null,
    endDate: null,  
    breederId: null,
    changeSignature: false,
    loadingSignature: false,
    loading: true,
    loadingBreeders: false,
    dataBreeders:[],
    toa: [],
    breeds: [],
    breedId: null,
    PetId: null,
    searchedBreeders: [],
  };

  tableHeaderBreederColumnData = [
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
      style: { "overflowX": "visible" },
      headerStyle: (column, colIndex) => {
        return { width: '70px' };
      }
    },
    {
      dataField: "id",
      text: "Signature",
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '220px' };
      },
      formatter: (cell, row) => {
        return (
          <span>
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.signature_path
              }
              style={{ maxWidth: "100px", marginBottom: "10px" }}
              alt=""
            />
            {this.state.changeSignature == false ?
              <div className="form-group m-form__group row">
                {/* <label className="col-lg-4 col-form-label">Select Image</label> */}
                <div className="col-lg-6">
                  <input
                    ref={this.file}
                    type="file"
                    accept="image/*"
                    name="imgName"
                    onChange={this._onChange}
                  />

                </div>
              </div>
              :
              null
            }
            <div className="m-widget4__info ml-0 pl-0 my-0 mt-1 col-sm-6">
              <button onClick={() => this.saveSignature(row.id)} type="button" style={{ borderRadius: "1px", fontSize: "10px", padding: "6px" }} className="btn m-btn--pill btn-outline-primary"><i className="fas fa-cloud-upload-alt"></i> Save</button>
            </div>

          </span>
        );
      }
    },
    {
      dataField: 'breeder', text: 'Name', sort: true,
    },
    {
      dataField: 'usda_no', text: 'USDA No', sort: true
    },
    {
      dataField: 'addressLine1', text: 'Address Line 1', sort: true
    },
    {
      dataField: 'addressLine2', text: 'Address Line 2', sort: true
    },
    {
      dataField: 'addressCity', text: 'City', sort: true
    },
    {
      dataField: 'addressState', text: 'State', sort: true
    },
    {
      dataField: 'addressCountry', text: 'Country', sort: true
    },
    {
      dataField: "is_visible_on_pdf",
      text: "Eligible",
      sort: true,
      formatter : (cell,row) => {
        return (         
          <div>
            <Switch
              onChange={(e) => { this.updateBreederAvailability(e, row); }}
              key={row.id}
              checked={row.is_visible_on_pdf}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor={"#34bfa3"}
              offColor={"#f4516c"}
            />                    
          </div>
      )}     
    },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true,
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity  row={row} created={row.createdBreeder} updated={row.updatedBreeder} deleted={row.deletedBreeder}/>
        );
      },
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }
  ];

  _onChange = (event) => {
    // Assuming only image
    event.persist();
    this.setState({ imageFile: event.target.files[0] });
    var file = event.target.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      this.setState({
        imgSrc: reader.result,
        imgName: file
      });
    }.bind(this);
  }

  changeSignature = () => {
    // this.setState({changeSignature: true});
    return this.props.fetchBreeders();
  }

  buttonFormatter(cell, row, rowIndex) {

    let data = this.state.contentData;

    let index = _.findIndex(data, {id: row.id});  //_.chunk(contentData, row.id)

    let previndex = (index == 0) ? null : (index - 1);
    let nextindex = index + 1;

    let prevEle = nextindex != null ? data[nextindex] ? data[nextindex].id : null : null;
    let nextEle = previndex != null ? data[previndex] ? data[previndex].id : -1 : -1; 

    return (
      <div>    
        <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <NavLink
                to={`/breeders/${row.id}`}
                className="dropdown-item"
                title="View"
              >
                <i className="la la-edit"></i> Edit
              </NavLink>       
               <a
                className="dropdown-item"
                onClick={(e) => { this.openBreederDeleteModal(e,row.id) }}
              >
                <i className="la la-trash-o"></i> Delete
              </a>
            </div>
          </span>
        </span>
      </div>
    );
  }

  handleSelect(dates) {


    const [start, end] = dates;

    if (start) {
      _self.setState({ startDate: start });
    }

    if (end) {
      _self.setState({ endDate: end });
    }

    if (_self.state.startDate && _self.state.endDate) {
      _self.setState({ selected: _self.state.startDate + " - " + _self.state.endDate });
    }
  }

  setStartDate(date) {
    _self.setState({ endDate: null, startDate: date });

    _self.component.setOpen(true);
  }

  setEndDate(date) {
    _self.setState({ endDate: date });
  }

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  acceptMethodsForPdf(childDoDownload) {
    // Parent stores the method that the child passed
    this.childDoDownload = childDoDownload;
  }

  openRejectModal(e) {
    e.preventDefault();
    $("#reject_modal").modal("show");
  }

  openConfirmModal(e, mrId) {
    e.preventDefault();
    this.setState({ deleteMRId: mrId });
    $("#confirm_delete_modal").modal("show");
  }

  openBreederDeleteModal(e,breederId) {  
    this.setState({breederId: breederId});
    $('#confirm_delete_modal').modal('show');
  }

  openInstagramPostModal(e, row) {
    e.preventDefault();
    this.setState({ current_row: row });
    $("#instagram_post_modal").modal("show");
  }

  openDeliveryModal(e, data) {
    e.preventDefault();
    // this.setState({ dataBreederSendData: data });
    let sdate = moment();
    let edate = moment().add(7, 'days');
    // edate.setDate(sdate.getDate()+7);
    _self.setState({ startDate: sdate, endDate: edate });
    $("#breeder_delivery_list_modal").modal("show");
  }

  changeToa = selected => {
    if (selected) {
      this.setState({ PetId: selected.value, searchedBreeders : [] });
    }
  };
    
  changeBreed = (selected) => {
    let selectedBreedType = selected ? selected.value : null ;        
    this.setState({ breedId : selectedBreedType, searchedBreeders : [] } );
    
  }
    
  searchBreeders = (e) => { 
    if(this.state.breedId && this.state.breedId !== 'none' ){ 
     this.props.getBreedersViaBreedType(this.state.breedId);
    }
    else{
     NotificationManager.warning("Please select breed first");
    }
  }
    
  closeBreederSearchModal = () =>{
    $("#breeder_search_modal").modal("hide");
    this.setState({ searchedBreeders : [], breedId: null, PetId : null, breeds :[] });
  }

  saveSignature = async (id) => {
    let _self = this;
    this.setState({ loadingSignature: true, loading: true });
    let formData = new FormData();
    formData.append('file', this.state.imageFile);
    let result = await attachSignature(id, formData);

    result.payload.then(async resp => {
      _self.setState({ breederData: [] });

      await _self.changeSignature();

      _self.setState({ loading: false });

      NotificationManager.success("Signature Updated Successfully");

    })

    // window.location.reload();
  }

  updateBreederAvailability = (status,row) => {  
    if(row && row.id){  
      const statusNew = status;
      let breederData = {
        confirmExisting: true,
        is_visible_on_pdf : status
      }
      
      this.props.updateBreeder(row.id, breederData);   
    }
  }



  componentDidMount() {  
    this.props.fetchBreeders();
    this.props.fetchAnimalTypes();
    // this.props.fetchBreederDeliveryRecords();
  }

  componentWillReceiveProps = nextProps => { 
    if (nextProps.data.breederReducer.breederList !== this.props.data.breederReducer.breederList) {
      this.setState({ breederData: nextProps.data.breederReducer.breederList, loading : false });
    }

    if(nextProps.data.breederReducer.breederListError !== this.props.data.breederReducer.breederListError ){  
      NotificationManager.error("An error occurred while loading the breeders");
      this.setState({ loading : false });
    }

    if (this.props.data.breederReducer.deletedBreeder !== nextProps.data.breederReducer.deletedBreeder) {
      this.setState({ loadingDelete: false });
      $('#confirm_delete_modal').modal('hide');
      this.props.fetchBreeders();
      NotificationManager.success("Breeder Deleted Successfully");
    }

    if (this.props.data.breederReducer.deletedBreederError !== nextProps.data.breederReducer.deletedBreederError) {
      if(nextProps.data.breederReducer.deletedBreederError && nextProps.data.breederReducer.deletedBreederError.message){
        this.setState({ loadingDelete: false });
        $('#confirm_delete_modal').modal('hide');
        this.props.fetchBreeders();
        NotificationManager.warning(nextProps.data.breederReducer.deletedBreederError.message);
      }

    }

    if (this.props.data.breederReducer.newSignature !== nextProps.data.breederReducer.newSignature) {
      this.setState({ loadingSignature: false, changeSignature: false });
      NotificationManager.success("Signature Updated Successfully");
    }
    if (this.props.data.breederReducer.newSignatureError !== nextProps.data.breederReducer.newSignatureError) {
      this.setState({ loadingSignature: false, changeSignature: false });
      NotificationManager.error("Failed to update Signature.");
    }

    if ( nextProps.toa && this.props.toa !== nextProps.toa && nextProps.toa.length > 0 ) {
      let options = [];
      nextProps.toa.map(p => {
        options.push({ label: p.type, value: p.id });
      }); 
      this.setState({ toa: options });
      if (nextProps.toa.length > 0) {
        this.setState({ PetId: nextProps.toa[0].id });
      }
    }
      
    if( nextProps.breeds && this.props.breeds !== nextProps.breeds ) {
      let options = [{ label: "SELECT BREED", value: "none" }];
      nextProps.breeds.map(p => {
         options.push({ label: p.breed_type, value: p.id });
      });
      this.setState({ breeds: options,  breedId: null });  
    }
      
    if( this.props.searchedBreeders !== nextProps.searchedBreeders){   
        let isEmptySearch = nextProps.searchedBreeders && nextProps.searchedBreeders.length > 0 ? false : true;        
        if(!isEmptySearch){
          this.setState({ searchedBreeders : nextProps.searchedBreeders }); 
        }else{
          NotificationManager.warning("Breeders not found");
        }
    }

    if (
      this.props.data.breederReducer.updatedBreeder !==
      nextProps.data.breederReducer.updatedBreeder
    ) {
      let breederObj = nextProps.data.breederReducer.updatedBreeder;  
      this.props.fetchBreeders();
    }

  };

  componentDidUpdate(prevProps, prevState) {    
    if (this.state.PetId && prevState.PetId !== this.state.PetId) {
          this.props.fetchBreedTypesByAnimal(this.state.PetId);      
    }
 
  }

  handleClickOpen = () => {
    this.setState({ openNew: true });
  };  

  handleDelete = selected => {
    if (!(selected === null || selected === undefined) && selected !== 0) {
      this.setState({ confirmDelete: true, selected });
    }
  };

  deleteMRecord() {
    this.setState({ loadingDelete: true });

    if (this.state.deleteMRId) this.props.deleteMRecords(this.state.deleteMRId);
    else {
      NotificationManager.warning("Invalid medical record.");
      this.setState({ loadingDelete: false });
    }
  }

  deleteBreeder(e){
    e.preventDefault();  
    this.props.deleteBreeder({id:this.state.breederId});
  }

  handleChildUnmount() {
    this.setState({ clickedId: false });
  }

  handleRedirectClick = () => {
    this.props.history.push("/medical-records/deleted");
  }

  openSearchModal = () =>{
    $("#breeder_search_modal").modal("show");
  }
  
  items = [{ title: "Breeders", to: "/breeders" }];

  render() {
    const { classes, theme, pdfStatus } = this.props;
    const {
      contentData,
      cdSold,
      cdDraft,
      cdDeleted,
      current_row,
      startDate,
      endDate,
      selected,
      breederData,
      toa,
      PetId,
      breeds,
      breedId,
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set" >
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Breeders                     
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <NavLink
                      to={`/breeders/add`}
                      className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                    >
                      <span>
                        <i className="la la-plus"></i>
                        <span>New Breeder</span>
                      </span>
                    </NavLink>
                    <a href="#"
                      className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill ml-2"
                       onClick={(e)=>{ this.openSearchModal()}}
                    >
                      Breeder Search
                    </a>
                  </div>                
                </div>
                <div className="m-portlet__body medical-record-content">  

                {this.state.loading ?
                  <div className="center-row" >
                    <Loader size={50} />  
                  </div>
                   :         
            
                    <ToolkitProvider
                      keyField="id"
                      data={ breederData }
                      columns={this.tableHeaderBreederColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>                 
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                            />                        
                        </div>
                      )}
                    </ToolkitProvider>  
                    }            
                </div>
              </div> 
            </div>
          </div>
        </div>
        <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm to delete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this breeder?</p>
                        </div>
                        <div className="modal-footer">                    
                            <div>
                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                <button type="button" onClick={(e) => this.deleteBreeder(e)} className="btn btn-primary m-btn--pill">Confirm</button>
                            </div>                    
                      
                        </div>
                    </div>
                </div>
        </div>
      {/* Breeder search model start */}
       <div
          className="modal fade"
          id="breeder_search_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Breeder Search
                      </h5>
                      <button
                        type="button"
                        className="close"
                        onClick={(e)=>{ this.closeBreederSearchModal(e)}}
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
               </div>
              <div className="modal-body">
                      <div className="m-form__section">
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Type of Animal
                        </label>
                        <div className="col-lg-8">
                          <Select     
                            options={toa}  
                            value={PetId}                                        
                            name="PetId"    
                            onChange={this.changeToa}   
                            type="text"    
                          />                                  
                        </div>
                      </div>
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Breed
                        </label>
                        <div className="col-lg-8">
                          <Select              
                          options={breeds}
                          value={breedId}
                          name="breedId"
                          onChange={this.changeBreed}
                          placeholder="Select the breed"
                          />                                  
                        </div>
                      </div>
                      <div className="form-group m-form__group row justify-content-end">
                        {/* <label className="col-lg-4 col-form-label">
                          Breed:
                        </label> */}
                        <div className="col-lg-3">
                          <button
                            type="button"
                            onClick={e =>
                              this.searchBreeders(e)
                            }
                            className="btn m-btn--pill btn-outline-primary btn-sm mx-2"                    
                          >
                            Search
                          </button>                                                  
                        </div>
                      </div>
                      <div className="form-group m-form__group row">                  
                        <div className="col-lg-12">  
                        {/* start */}
                        { this.state.searchedBreeders && this.state.searchedBreeders.length > 0 &&
                        <div className="m-widget4 border border-dark rounded px-3">
                          { this.state.searchedBreeders.map((item,index)=>(
                                <div className="m-widget4__item" key={index}>                       
                                <div className="m-widget4__info">
                                  <span className="m-widget4__title">
                                  {item.breeder}
                                  </span>
                                  <br/>
                                  <span className="m-widget4__sub">
                                  {item.addressLine1}
                                  </span>
                                  <br/>
                                  <span className="m-widget4__sub">
                                  {item.addressLine2} 
                                  </span>
                                  <br/>
                                  <span className="m-widget4__sub">
                                    {item.addressCity}
                                  </span>
                                  <br/>
                                  <span className="m-widget4__sub">
                                    <a href={`mailto:${item.email}?body=Hello, ${toCapitalize(item.breeder)}!`} className="hyperlink">
                                      <strong>{item.email}</strong>    
                                    </a>                             
                                  </span>
                                </div>
                                <div className="m-widget4__ext">
                                  <a href={`tel:${item.phone}`} className="hyperlink-phone-number">
                                  {item.phone}
                                  </a>
                                  {/* <span className="m-badge mx-auto my-0 px-1 m-badge--primary ">{item.phone}</span> */}
                                </div>
                                </div>   
                          ))                      
                          }               
                        </div>   
                        }                      
                        {/* end */}                                    
                          </div>
                      </div>
                      </div>               
              </div>
             </div>
           </div>
      </div>
      {/* Breeder search model end */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state,
  toa: state.addAnimalTypeReducer.animalTypes,
  reg_types: state.regTypeReducer.regTypes,
  toaError: state.addAnimalTypeReducer.animalTypesError,
  reg_types_error: state.regTypeReducer.regTypesError,
  mRecordsError: state.medicalRecordsReducer.mRecordsError,
  pdfStatus: state.medicalRecordsReducer.pdfStatus,
  breeds: state.addBreedTypeReducer.breedsByAnimal,
  searchedBreeders : state.breederReducer.searchedBreeders,

});

const mapDispatchToProps = dispatch => ({
  fetchBreeders: () => {
    dispatch(fetchBreeders());
  },
  deleteBreeder: (id) => {
    dispatch(deleteBreeder(id));
  },
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchBreedTypesByAnimal: animal => {
    dispatch(fetchBreedTypesByAnimal(animal));
  },
  getBreedersViaBreedType: (breed)=> {
    dispatch(getBreedersViaBreedType(breed));
  },
  updateBreeder: (id, data) => {
    dispatch(updateBreeder(id, data));
  },
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
